import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import MainContent from '../../../components/MainContent';
import PageTitle from '../../../components/Common/PageTitle/PageTitle';
import Pagination from '../../../components/Common/Pagination';
import ActivityLoader from '../../../components/Common/ActivityLoader';
import Notification from '../../../components/Common/Notification';
import ActionDropdownItem from '../../../components/Common/PageTitle/ActionDropdownItem';
import { useTheme } from '../../../DataStore/ThemeContext';
import { useGym } from '../../../DataStore/Gym/GymContext';
import NewClassModal from '../../../components/Gym/NewClassModal';
import ScheduledClassCards from '../../../components/Gym/ScheduledClassCards';
import ScheduleClassModal from '../../../components/Gym/ScheduleClassModal';

const GymClassesPage = () => {
    const [showNewClassModal, setShowNewClassModal] = useState(false);
    const [showScheduleClassModal, setShowScheduleClassModal] = useState(false);
    const [selection, setSelection] = useState(null);

    const {
        getGymClasses,
        gymClasses,
        scheduledClasses,
        getScheduledClasses,
        metaData,
        setCurrentPage,
    } = useGym();

    const { setNotify } = useTheme();

    useEffect(() => {
        getGymClasses();
        getScheduledClasses();
    }, []);

    const handleNewClass = () => {
        setShowNewClassModal(true);
    };

    const PageActions = () => (<>
        <ActionDropdownItem iconClass="fa fa-plus text-success" label="New Class" onClick={handleNewClass} />
        <ActionDropdownItem iconClass="fa fa-calendar-alt text-primary" label="Schedule Class" onClick={() => setShowScheduleClassModal(true)} />
        <ActionDropdownItem iconClass="fa fa-refresh text-info" label="Refresh" onClick={() => getGymClasses(true)} />
    </>);

    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Gym Classes"
                    description="Manage gym classes and schedules."
                    iconClass="fa fa-dumbbell"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? <Pagination metaData={metaData} onPageChange={(page) => setCurrentPage(page)} /> : <></>}
                />

                <div className="row">
                    <div className="col-lg-8 col-md-12 mb-3">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <span>Registered Classes</span>
                                <button className="btn btn-sm btn-success" onClick={handleNewClass}>
                                    <i className="fa fa-plus mr-1"></i> New Class
                                </button>
                            </div>
                            <div className="card-body overflow-auto" style={{ maxHeight: '40vw' }}>
                                <table className="table table-hover">
                                    <thead className="table-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Class Name</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(gymClasses) && gymClasses.map((item, index) => (
                                            <tr key={item.id} onClick={() => setSelection(item)} className={`link ${selection?.id === item.id ? 'selected-row' : ''}`}>
                                                <td>{index + 1}</td>
                                                <td>{item.class_name}</td>
                                                <td>{item.description}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {!gymClasses && <ActivityLoader />}
                                {gymClasses === "404" && <Notification message="No classes found." closable={false} />}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-12 mb-3">
                        <ScheduledClassCards 
                            scheduledClasses={scheduledClasses} 
                            onSchedule={() => setShowScheduleClassModal(true)} 
                        />
                    </div>
                </div>

            </MainContent>
        </PageContainer>
        <NewClassModal show={showNewClassModal} onClose={() => setShowNewClassModal(false)} onClassCreated={() => getGymClasses(true)} />
        <ScheduleClassModal show={showScheduleClassModal} onClose={() => setShowScheduleClassModal(false)} classDetails={selection} onClassScheduled={() => getScheduledClasses(true)} />
    </>
    );
};

export default GymClassesPage;
